<template>
  <place-autocomplete-container @submit="handlePlaceSubmit"/>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import store from '@/store'
import {
  ACTIVATE_PLACE_PICKER,
  DEACTIVATE_PLACE_PICKER,
  SET_NEW_PLACE,
  SET_PLACE_TITLE,
  SET_PLACE_PICKER_POSITION
} from '@/store/mutation-types'

import PlaceAutocompleteContainer from '@/containers/PlaceAutocompleteContainer'

export default {
  components: {
    PlaceAutocompleteContainer
  },
  computed: {
    ...mapState({
      title: state => state.picker.title,
      position: state => state.picker.position
    })
  },
  beforeRouteEnter (to, from, next) {
    store.commit(ACTIVATE_PLACE_PICKER)

    // Map place specs to place picker
    if (store.state.contest.place.title) {
      store.commit(SET_PLACE_TITLE, store.state.contest.place.title)
      store.commit(SET_PLACE_PICKER_POSITION, store.state.contest.place.coords)
    }

    next()
  },
  beforeRouteLeave (to, from, next) {
    store.commit(DEACTIVATE_PLACE_PICKER)
    next()
  },
  methods: {
    ...mapMutations({
      setNewPlace: SET_NEW_PLACE
    }),
    handlePlaceSubmit () {
      this.setNewPlace({
        title: this.title,
        coords: this.position
      })
      this.$router.push({ name: 'add-step-1' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/AddPlace/AddPick.vue